<template>
    
    <v-container class="prinCon">
        <div class="prin">
            <div class="logo">
                <div>
                    <v-img alt="logo" class="icon" src="../assets/img/logo-letters-icon.svg"></v-img>
                </div>
                <h2 class="date text-white">{{ formattedDate }}</h2>
            </div>
            <div class="log_in">
                <v-card class="contenedor">
                    <div class="logo_movil_contenedor">
                        <v-img alt="logo" src="../assets/img/compliance-logo.svg" class="logo_movil"></v-img>
                    </div>

                    <v-card-title class="text-h6 font-weight-regular justify-space-between">
                        <span>{{ currentTitle }}</span>
                    </v-card-title>

                    <v-window v-model="step" class="steps">
                        <v-window-item :value="1">
                            <v-card-text>
                                <v-text-field label="Email" clearable variant="solo-filled"></v-text-field>
                                <span class="text-caption text-grey-darken-1">
                                    This is the email you will use to login to your account
                                </span>
                            </v-card-text>
                        </v-window-item>

                        <v-window-item :value="2">
                            <v-card-text>
                                <v-text-field label="Password" type="password" clearable
                                    variant="solo-filled"></v-text-field>
                                <span class="text-caption text-grey-darken-1">
                                    Enter a password for your account
                                </span>
                            </v-card-text>
                        </v-window-item>
                    </v-window>

                    <v-card-actions>
                        <v-btn v-if="step > 1" @click="step--" elevation="4" color="error" variant="flat"
                            append-icon="mdi mdi-window-close">
                            Cancelar
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn v-if="step < 2" @click="step++" elevation="4" color="success" variant="flat"
                            append-icon="mdi mdi-chevron-right">
                            Siguiente
                        </v-btn>
                        <v-btn v-if="step == 2" elevation="4" append-icon="mdi mdi-login" color="success" variant="flat"
                            to="/Dashboard">
                            Login
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </div>
        </div>
    </v-container>
</template>
<style>
.prinCon,
.prin {
    width: 100%;
    height: 100%;
    background: linear-gradient(315deg, #000000, #4792ff);
    display: flex;
}

.logo,
.log_in {
    width: 50%;
    height: 100%;
    display: flex;
    align-items: center;
}

.icon {
    width: 700px;
    height: 700px;
}

.logo {
    flex-direction: column;
}

.contenedor {
    width: 540px;
    height: 650px;
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.session-form {
    display: flex;
    flex-direction: column;
    align-items: center;
}

/* Estilos para pantallas menores a 768px (normalBar oculto, movilBar visible) */
@media screen and (max-width: 767px) {
    .logo {
        display: none;
    }

    .log_in {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .contenedor {
        width: 450px;
        height: 650px;
        display: flex;
        align-items: center;
    }

    .v-text-field {
        width: 300px;
    }

    .logo_movil,
    .logo_movil_contenedor {
        width: 100px;
        height: 100px;
    }
}

/* Estilos para pantallas mayores o iguales a 768px (normalBar visible, movilBar oculto) */
@media screen and (min-width: 768px) {
    .logo_movil {
        display: none;
    }
}
</style>

<script>
export default {
    data() {
        return {
            currentDate: new Date(),
            step: 1,
        };
    },

    computed: {
        currentTitle() {
            switch (this.step) {
                case 1:
                    return "Correo";
                case 2:
                    return "Contraseña";
            }
        },
        formattedDate() {
            const options = {
                weekday: "long",
                day: "numeric",
                month: "long",
                year: "numeric",
                hour: "numeric",
                minute: "numeric",
                hour12: true,
            };

            return this.currentDate.toLocaleString("es-ES", options);
        },
    },
    mounted() {
        // Actualizar la fecha cada segundo
        this.timer = setInterval(() => {
            this.currentDate = new Date();
        }, 1000);
    },
    beforeDestroy() {
        // Limpiar el intervalo al destruir el componente
        clearInterval(this.timer);
    },
};
</script>
